import { gql } from '@apollo/client';

// Fragment-only module, with no component or heavy-library imports, so the global
// fragment registry can register this fragment without pulling the chip, and the
// tables and calendars it reaches, into the boot-time entry chunk.

export const CLINICIAN_CHIP_FRAGMENT = gql`
    fragment ClinicianChip on Clinician {
        id
        firstName
        lastName
        logoUrl
        isActive
    }
`;
